import angular from 'angular';
import { ListagemService } from '../../../../shared/services/listagem.service';
import { AgenciasService } from '../../../Financas/Agencias/agencias.service';
import { Empresa, Estabelecimento } from '../../../../core/usuario/models/usuario-model';
import { TrabalhadoresService } from '../../../Trabalhadores/trabalhadores.service';
import { TipoContaPixEnum } from '../../../../shared/enums/TipoContaPixEnum';
import {
  contaBancoValida,
  getMensagemContaBanco,
  digitoVerificadorContaValido,
  getMensagemDigitoVerificador,
  TipoPagamentoEnum
} from '../../../../utils/dados-bancarios';

export class MeurhSolicitacoesalteracoesdadossalariaisFormController implements angular.IController {
	static $inject = [
    '$scope',
    '$element',
    '$attrs',
    'NewToaster',
    '$stateParams',
    '$rootScope',
    'ListagemService',
    'TrabalhadoresService',
    'AgenciasService',
  ];

  public tipo: string = this.$stateParams.tipo;
  public action: string;
  public busy: boolean;
	public form: angular.IFormController;
  public entity: any;
  public filter: any;

  public filters = {
    empresa: this.$rootScope.session.entities.empresa.empresa,
    estabelecimento: this.$rootScope.session.entities.estabelecimento.estabelecimento
  };
  public empresas: Array<Empresa>;
  public estabelecimentos: Array<Estabelecimento>;

  public listagemPermissao: Array<string> = ['criar_alteracaotiporecebimento'];
  public permissaoGrupoEmpresarial = this.$rootScope.temPermissaoGrupoEmpresarial(this.listagemPermissao, this.$rootScope.nsjGlobals.a.grupoempresarial);

  public constructorLookupColaborador;

  public tipoRecebimentoOriginal;
  public chavePixOriginal;
  public tipoContaPixOriginal;
  public bancoOriginal;
  public agenciaNumeroOriginal;
  public numeroContaOriginal;
  public numeroContaDvOriginal;
  public agenciaNumeroDvOriginal;

  public tipoContaPixEnum = TipoContaPixEnum;

  public exibeAlertaConta: boolean = false;
  public focoInputConta: boolean = false;

  public exibeAlertaDigitoVerificador: boolean = false;
  public focoInputDigitoVerificador: boolean = false;

  public agenciaExistente = false;

  public tiposPagamentoChecaDv = [
      TipoPagamentoEnum.CONTA_CORRENTE,
      TipoPagamentoEnum.CONTA_POUPANCA,
      TipoPagamentoEnum.CONTA_SALARIO,
      TipoPagamentoEnum.PIX_AGENCIA_CONTA
  ];

  constructor (
    public $scope: angular.IScope,
		public $element: any,
		public $attrs: any,
		public NewToaster: any,
		public $stateParams: angular.ui.IStateParamsService,
		public $rootScope: angular.IRootScopeService & {
      temPermissao: (arg: string) => boolean,
      modoGestorPermissao: (arg: string) => boolean,
      temPermissaoGrupoEmpresarial: (permissoes: Array<string>, grupo: string) => boolean,
      liberadoTela: (arg: string) => boolean,
      session: any,
      nsjGlobals: any,
      configuracoes: any,
    },
    public ListagemService: ListagemService,
    public TrabalhadoresService: TrabalhadoresService,
    public AgenciasService: AgenciasService,
  ) {

    $scope.$on('agencias_list_finished', (event, args: { numero: string; digitoverificador: string; }[]) => {
        if (args && args.length) {
            const agencia = args.find(agencia => agencia.numero === this.entity.agencianumero);
            if (agencia) {
                this.entity.agencianumerodv = agencia.digitoverificador;
            }
            this.agenciaExistente = !!agencia;
            return;
        }
        this.agenciaExistente = false;
    });

    $scope.$watch('$ctrl.entity', (newValue: any, oldValue: any) => {
      if (newValue !== oldValue) {
        this.form.$setDirty();
      }
    }, true);
  }

  $onInit(): void {

    this.entity.estabelecimento = this.action !== 'show' ? this.filters.estabelecimento : this.entity.estabelecimentoobj.estabelecimento;
    this.montaListagemVisibilidade();

    this.constructorLookupColaborador = {
      'empresa': this.filters.empresa,
      'estabelecimento': this.filters.estabelecimento,
      'status': '00',
      'forcagestor': this.forcaGestor(),
      ...(this.tipo && { 'tipo': this.tipo }),
    };
  }

  montaListagemVisibilidade(): void {
    if (this.action === 'show') {
      this.filters.empresa = this.entity.estabelecimentoobj.empresa;
      this.filters.estabelecimento = this.entity.estabelecimentoobj.estabelecimento;
    }
    this.empresas = this.ListagemService.montaEmpresas(this.$rootScope.nsjGlobals.a.grupoempresarial, this.listagemPermissao);
    this.estabelecimentos = this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas, this.listagemPermissao);
  }

  mudaEstabelecimentos(): void {
    this.estabelecimentos = this.filters.empresa ? this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas, this.listagemPermissao) : [];
    this.filters.estabelecimento = '';
    this.filtraEmpresaEstabelecimento();
  }

  filtraEmpresaEstabelecimento(): void {
    this.constructorLookupColaborador = {
      'empresa': this.filters.empresa,
      'estabelecimento': this.filters.estabelecimento,
      'status': '00',
      'forcagestor': this.forcaGestor(),
      ...(this.tipo && { 'tipo': this.tipo }),
    };
  }

  forcaGestor(): boolean {
    return this.$rootScope.modoGestorPermissao('criar_alteracaotiporecebimento');
  }

  public async getInfosColaborador(idColaborador: string) {

    if (idColaborador) {
      this.entity.estabelecimento = this.entity.trabalhador.estabelecimentoobj.estabelecimento;
      await this.TrabalhadoresService.get(idColaborador).then((dadosColaborador) => {
        this.entity.tiporecebimento = dadosColaborador.tiporecebimentosalario ? dadosColaborador.tiporecebimentosalario.toString() : null;
        this.entity.tipocontapix = dadosColaborador.tipocontapix ? dadosColaborador.tipocontapix.toString() : null;

        if (this.entity.tiporecebimento === '128' ||
          this.entity.tiporecebimento === '256' ||
          this.entity.tiporecebimento === '512') {
            this.preencheChavePixColaborador(this.entity.tiporecebimento, dadosColaborador);
        } else {
          this.entity.chavepix = null;
        }

        this.entity.banco = dadosColaborador.banco ? dadosColaborador.banco : null;
        this.entity.agencianumero = dadosColaborador.agencia ? dadosColaborador.agencia.numero : null;
        this.entity.numeroconta = dadosColaborador.numerocontasalario;
        this.entity.numerocontadv = dadosColaborador.numerocontasalariodv;
        this.entity.agencianumerodv = dadosColaborador.agencia ? dadosColaborador.agencia.digitoverificador : null;

        this.agenciaExistente = !!dadosColaborador.agencia;

        // guardando informações bancárias do colaborador carregadas inicialmente. Serão usadas para comparar se houve mudança nesses dados
        this.tipoRecebimentoOriginal = this.entity.tiporecebimento;
        this.tipoContaPixOriginal = this.entity.tipocontapix;
        this.chavePixOriginal = this.entity.chavepix;
        this.bancoOriginal = this.entity.banco;
        this.agenciaNumeroOriginal = this.entity.agencianumero;
        this.numeroContaOriginal = this.entity.numeroconta;
        this.numeroContaDvOriginal = this.entity.numerocontadv;
        this.agenciaNumeroDvOriginal = this.entity.agencianumerodv;

        this.verificaMudancaDadosBancarios();
        this.validaContaPagamento();
        this.validaDigitoVerificadorConta();

      });
    } else {
      this.entity.estabelecimento = null;
      this.limpaDadosBancarios();
    }

  }

  public preencheCamposRecebimento(): void {

    switch (this.entity.tiporecebimento) {
      case '128': // cpf
        this.entity.chavepix = this.entity.trabalhador.cpf;
        break;

      default:
        this.entity.chavepix = null;
        break;
    }
  }

  public preencheChavePixColaborador(tiporecebimento: string, dadosColaborador: any) {

    switch (tiporecebimento) {
      case '128': // cpf
        this.entity.chavepix = dadosColaborador.cpf;
        break;

      case '256': // email
        this.entity.chavepix = dadosColaborador.email;
        break;

      case '512': // celular
        this.entity.chavepix = dadosColaborador.dddcel + dadosColaborador.celular;
        break;
    }

  }

  limpaDadosBancarios() {
    this.entity.tiporecebimento = null;
    this.entity.tipocontapix = null;
    this.entity.chavepix = null;
    this.entity.banco = null;
    this.entity.agencianumero = null;
    this.entity.agencianumerodv = null;
    this.entity.numeroconta = null;
    this.entity.numerocontadv = null;
    this.agenciaExistente = false;
  }

  /**
   * Método que verifica se algum dos dados bancários do colaborador foi alterado
   */
  verificaMudancaDadosBancarios() {
    if (this.tipoRecebimentoOriginal !== this.entity.tiporecebimento ||
      this.tipoContaPixOriginal !== this.entity.tipocontapix ||
      this.chavePixOriginal !== this.entity.chavepix ||
      this.bancoOriginal?.banco !== this.entity.banco?.banco ||
      this.agenciaNumeroOriginal !== this.entity.agencianumero ||
      this.numeroContaOriginal !== this.entity.numeroconta ||
      this.numeroContaDvOriginal !== this.entity.numerocontadv ||
      this.agenciaNumeroDvOriginal !== this.entity.agencianumerodv
    ) {
      this.mudouInfoColaborador(true);
    } else {
      this.mudouInfoColaborador(false);
    }
  }

  verificaAgencia() {
    this.agenciaExistente = false;
    if (this.entity.agencianumero) {
        this.AgenciasService.constructors = { banco: this.entity.banco.banco };
        this.AgenciasService.search({ search: this.entity.agencianumero });
    }
  }

  /**
   * Dispara broadcast informando se alguma informação do colaborador foi alterada
   */
  mudouInfoColaborador(mudouInfo: boolean) {
    this.$rootScope.$broadcast('dados_bancarios_colaborador_change', mudouInfo);
  }

  public desabilitarNenhumTipoPagamento(): boolean {
    return !!this.$rootScope.configuracoes.DESABILITAR_NENHUM_TIPO_PAGAMENTO_ADMISSOES;
  }

  public alertaTipoPagamento(): boolean {
    return !(!!this.entity.tiporecebimento) && (this.form && (this.form.tiporecebimento.$dirty || this.form.$submitted));
  }

  public alertaTipoContaPix(): boolean {
    return this.entity.tiporecebimento === '64' &&  !(!!this.entity.tipocontapix) && (this.form && (this.form.tipocontapix.$dirty || this.form.$submitted));
  }

  public desabilitarNenhumaInstituicaoBancaria(): boolean {
    return !!this.$rootScope.configuracoes.DESABILITAR_NENHUMA_INSTITUICAO_BANCARIA_ADMISSOES;
  }

  public limpaDadosAgenciaConta() {
    this.entity.agencianumero = null;
    this.entity.agencianumerodv = null;
    this.entity.numeroconta = null;
    this.entity.numerocontadv = null;
    this.agenciaExistente = false;
  }

  public limpaBanco() {
    this.entity.banco = null;
  }

  public validaContaPagamento() {
    if (!this.entity.banco || !this.entity.tiporecebimento || !this.entity.numeroconta) {
      this.exibeAlertaConta = false;
      return;
    }

    this.exibeAlertaConta = !contaBancoValida(this.entity.banco, this.entity.tiporecebimento, this.entity.numeroconta, this.entity.tipocontapix) &&
      !this.form.numeroconta?.$error?.required &&
      this.action !== 'show';
  }

  public verificaExibicaoAlertaConta() {
    if (!this.entity.banco || !this.entity.tiporecebimento || !this.entity.numeroconta) {
      return false;
    }

    return !this.focoInputConta && this.exibeAlertaConta;
  }

  public getMensagemAlertaConta(): string {
    return getMensagemContaBanco(this.entity.banco, this.entity.tiporecebimento, this.entity.numeroconta, this.entity.tipocontapix);
  }

  public validaDigitoVerificadorConta() {
    if (!this.entity.banco || !this.entity.tiporecebimento || !this.entity.numerocontadv) {
      this.exibeAlertaDigitoVerificador = false;
      return;
    }

    this.exibeAlertaDigitoVerificador = !digitoVerificadorContaValido(this.entity.banco, this.entity.tiporecebimento, this.entity.numerocontadv, this.entity.tipocontapix) &&
      !this.form.numerocontadv?.$error?.required &&
      this.action !== 'show';
  }

  public verificaExibicaoAlertaDigitoVerificador() {
    if (!this.entity.banco || !this.entity.tiporecebimento || !this.entity.numerocontadv) {
      return false;
    }

    return !this.focoInputDigitoVerificador && this.exibeAlertaDigitoVerificador;
  }

  public getMensagemAlertaDigitoVerificador(): string {
    return getMensagemDigitoVerificador(this.entity.banco, this.entity.tiporecebimento, this.entity.numerocontadv, this.entity.tipocontapix);
  }

}
